import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { configureActions } from '../../../../../actions/configure.action';
import sensorsActions from '../../../../../actions/sensors.actions';
import helper from '../../../../../utils/helper';
import Loading from '../../../../Helpers/Loading';
import Backend from '../../../../Layouts/Backend';
import EditSensorPage from './EditSensorPage';
import qs from 'qs';
import { cloneDeep } from 'lodash';

class EditSensor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sensor: {},
      sensorTypes: [],
      loading: false,
      errors: '',
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.sensorTypes !== prevState.sensorTypes) {
      state.sensorTypes = nextProps.configure.sensorTypes;
    }
    if (nextProps.sensors.sensor !== prevState.sensor) {
      state.sensor = nextProps.sensors.sensor;
    }
    // if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
    //   state.isSubmitting = nextProps.configure.isSubmitting;
    // }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.sensors.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  componentDidMount() {
    const { sensorId, groupId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.setState({ loading: true }, async () => {
      await this.props.configureActions.getSpecificGroup(groupId);
      await this.props.configureActions.getSensorTypesByGroup(groupId);
      await this.props.sensorsActions.getSensorDetail(sensorId);
      this.setState({ loading: false });
    });
  }
  onEditSensor = (values) => {
    const _values = cloneDeep(values);
    _values.calibrationDate = _values.calibrationDate
      ? _values.calibrationDate.toISOString()
      : null;

    this.setState(
      { isSubmitting: true },
      async () =>
        await this.props.sensorsActions
          .editSensor(values.id, _values)
          .then(() => {
            const { groupId } = qs.parse(this.props.location.search, {
              ignoreQueryPrefix: true,
            });
            // history.push(`/configure/groups/maintain-db/${groupId}`);
            this.props.history.goBack();
          })
          .catch(() => this.setState({ isSubmitting: false })),
    );
  };
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    const _sensor = Object.assign({}, this.state.sensor);
    if (Object.keys(_sensor).length) {
      if (this.state.sensorTypes.length) {
        const result = this.state.sensorTypes.filter(
          (sensorType) => sensorType.id === _sensor.typeId,
        );
        if (result.length) {
          _sensor.typeName = result[0].typeName;
        } else _sensor.typeName = '';
      }
      if (_sensor.calibrationDate) {
        _sensor.calibrationDate = new Date(_sensor.calibrationDate);
      }
    }
    return (
      <EditSensorPage
        {...this.state}
        group={this.props.configure.group}
        sensor={_sensor}
        onEditSensor={this.onEditSensor}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    sensors: state.sensors,
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sensorsActions: bindActionCreators(
      Object.assign({}, sensorsActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSensor);
